import React, { useRef } from "react";
import Slider from "react-slick";
import reviewData from "../JsonData/reviewData.json";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { motion } from 'framer-motion';

const Review = () => {
  const slideInFromBottom = {
    initial: { opacity: 0, y: 50 },
    whileInView: { opacity: 1, y: 0 },
    viewport: { once: true, amount: 0.2 },
    transition: { duration: 0.8, ease: "easeOut" },
  };
  const sliderRef = useRef(null);

  const handleLeftClick = (e) => {
    e.preventDefault();
    if (sliderRef.current) {
      sliderRef.current.slickPrev();
    }
  };

  const handleRightClick = () => {
    if (sliderRef.current) {
      sliderRef.current.slickNext();
    }
  };

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 1500,
  
  appendDots: dots => (
    <div className="relative">
      <ul className="flex justify-center space-x-2 absolute -bottom-6 left-1/2 -translate-x-1/2">
        {dots.slice(0, 3)}
      </ul>
    </div>
  ),
  customPaging: i => (
    <button
      className="!w-10 !h-10 rounded-full bg-[#D8E2C6]  hover:opacity-80 transition duration-300"
    />
  ),




    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <section className="flex flex-col justify-center items-center w-full lg:pt-[200px] md:pt-[64px] pt-[120px] lg:px-[106px] md:px[64px] px-4  mb-[160px]">
      <motion.div className="text-[#151515] text-center mt-[120px]" {...slideInFromBottom}>
        <div className="w-full flex justify-center">
          <div className="flex items-center">
            <h2 className="lg:text-[24px] lg:leading-[22px] md:text-[18px] md:leading-[24px] text-[14px] leading-[14px] font-lora font-medium">
              Testimonials
            </h2>

            <div className="ml-2">
              <svg className="block md:hidden mt-2" width="32" height="1" viewBox="0 0 32 1" fill="none" xmlns="http://www.w3.org/2000/svg">
                <line y1="0.5" x2="32" y2="0.5" stroke="black" strokeWidth="0.5" />
              </svg>

              <svg className="hidden md:block lg:hidden mt-4" width="64" height="1" viewBox="0 0 64 1" fill="none" xmlns="http://www.w3.org/2000/svg">
                <line y1="0.5" x2="64" y2="0.5" stroke="black" strokeWidth="0.5" />
              </svg>

              <svg className="hidden lg:block mt-6" width="64" height="1" viewBox="0 0 64 1" fill="none" xmlns="http://www.w3.org/2000/svg">
                <line y1="0.5" x2="64" y2="0.5" stroke="black" strokeWidth="0.5" />
              </svg>
            </div>
          </div>
        </div>

        <h2 className="md:text-[24px] lg:text-[38px] text-[18px] py-[24px] font-lora font-bold">
          What People Say About Us
        </h2>
      </motion.div>

      <div className="lg:w-[1300px] lg:h-[300px] md:w-[704px] md:h-[240px] w-[340px] h-[200px] relative lg:mt-[96px] md:mt-[64px] mt-10">
        <Slider ref={sliderRef} {...settings}>
          {reviewData.map((review, index) => {
            const isEven = index % 2 === 0;
          return (
  <div key={review.id} className="lg:px-4 md:px-2 w-[340px] lg:w-[416px] h-full flex">
    <div
      className={`rounded-[16px] border-[0.5px] shadow-lg flex flex-col justify-between lg:min-h-[300px]  min-h-[240px] md:min-h-[260px] w-full p-4 ${
        isEven ? "bg-white" : "bg-[#F0F3EA]"
      }`}
    >
      <div className="flex items-start">
        <img
          src={review.image}
          alt={review.name}
          className="lg:w-[64px] lg:h-[64px] md:w-[48px] md:h-[48px] w-[40px] h-[40px] object-cover rounded-full border-4 border-gray-300 lg:border-[3px] lg:border-[#D8E2C6]"
        />
        <div className="ml-4 mt-2">
          <h3 className="text-[12px] font-outfit md:text-[14px] lg:text-[16px] ">
            {review.name}
          </h3>
          <p className="outfit-text">{review.place}</p>
        </div>
      </div>

      <div className="flex-grow lg:mt-[30px] md:mt-[20px] mt-[16px] mb-2">
        <p className="font-outfit text-[12px] md:text-[14px] lg:text-[16px] lg:leading-[24px] leading-[22px] letter-spacing:[1px]  text-center text-[#838383]">
          "{review.description}"
        </p>
      </div>

      {review.rating && (
        <div className="flex items-center space-x-1">
          {[...Array(5)].map((_, i) => (
            <span
              key={i}
              className={`text-lg ${i < review.rating ? "text-[#EC8C07]" : "text-gray-300"}`}
            >
              ★
            </span>
          ))}
        </div>
      )}
    </div>
  </div>
);

          })}
        </Slider>

        <div className="hidden md:flex absolute top-auto transform -translate-y-1 flex justify-end w-full lg:p-6 p-2 gap-2  ">
          <button
            onClick={handleLeftClick}
            className="bg-white border-2 lg:w-[40px] lg:h-[40px] w-[24px] h-[24px] md:w-[32px] md:h-[32px] flex items-center justify-center rounded-full hover:bg-gray-200 z-30"
          >
            <img
              src="/images/icon/forward_icon.svg"
              alt="Left Arrow"
              className="w-full h-full object-contain rotate-180"
            />
          </button>

          <button
            onClick={handleRightClick}
            className="bg-white border-2 lg:w-[40px] lg:h-[40px] w-[24px] h-[24px] md:w-[32px] md:h-[32px] flex items-center justify-center rounded-full hover:bg-gray-200 z-30"
          >
            <img
              src="/images/icon/forward_icon.svg"
              alt="Right Arrow"
              className="w-full h-full object-contain"
            />
          </button>
        </div>
      </div>
    </section>
  );
};

export default Review;
